"use client";

import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { useGetItemsPerRowResponsive } from "@faire/deprecated-retailer-visitor-shared/components/SearchProducts/utils";
import { useSearchPageShouldNotShowAnyFiltersForLoggedIn } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageShouldNotShowAnyFiltersForLoggedIn";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import React, { ReactNode } from "react";
import styled, { css } from "styled-components";

export const FiltersAndResultsSubLayout = ({
  filters,
  results,
}: {
  filters: ReactNode;
  results: ReactNode;
}) => {
  useTraceComponentRender("FiltersAndResultsSubLayout");

  const showNoSearchResultsContainer =
    useSearchPageShouldNotShowAnyFiltersForLoggedIn();

  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);
  const itemsPerRowResponsive = useGetItemsPerRowResponsive(isSideBarVisible);
  const itemsPerRow = useResponsiveValue(itemsPerRowResponsive);

  return (
    <CustomContainer
      $productGridColumnCount={itemsPerRow}
      $isSidebarOpen={isSideBarVisible}
      $hasNoResults={showNoSearchResultsContainer}
    >
      {filters}
      {results}
    </CustomContainer>
  );
};

const CustomContainer = styled.div<{
  $isSidebarOpen?: boolean;
  $productGridColumnCount?: number;
  $hasNoResults?: boolean;
}>`
  ${({ $isSidebarOpen, $productGridColumnCount, $hasNoResults }) => {
    if (!$hasNoResults) {
      if ($isSidebarOpen) {
        if ($hasNoResults) {
          return css`
            display: grid;
            gap: ${getSpacing("3x")};
            grid-template-columns: minmax(0, ${$productGridColumnCount}fr);
          `;
        } else {
          return css`
            gap: ${getSpacing("3x")};
            display: grid;
            grid-template-columns: minmax(0, ${$productGridColumnCount}fr);
            ${responsiveMediaQueries.desktopAndAbove} {
              display: grid;
              grid-template-columns: minmax(0, 1fr) minmax(
                  0,
                  ${$productGridColumnCount}fr
                );
            }
          `;
        }
      } else {
        return css`
          gap: ${getSpacing("3x")};
          display: grid;
          grid-template-columns: minmax(0, ${$productGridColumnCount}fr);
        `;
      }
    } else {
      return css`
        display: flex;
      `;
    }
  }};
`;
